<button
  (click)="auth.logout()"
  class="flex gap-2 items-center px-4 py-2 cursor-pointer bg-white hover:bg-orange-50 rounded-lg active:bg-orange-100 group fixed top-3 right-16 z-[1000]"
>
  <img
    loading="lazy"
    src="/assets/icons/Logout-Sidebar-Icon.svg"
    class="shrink-0 self-stretch w-6 aspect-square group-hover:icon-orange"
    alt="logout"
  />
  <p
    class="my-auto text-[15px] cursor-pointer text-slate-600 group-hover:text-orange-500 transition-all"
  >
    Logout
  </p>
</button>

<lib-sgh-navbar
  [sidenavData]="sidenavConfig"
  [toolbarData]="toolbarConfig"
  [expanded]="isNavExpanded"
  (toggleSidebarEvent)="onToggleSidebar($event)"
  (sidenavToggle)="onToggleSidebar($event)"
>
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</lib-sgh-navbar>
